import { createSlice } from '@reduxjs/toolkit';
import { fetchAllUnitMeasurements, createNewUnitMeasurement } from '../actions/unit_measurementsActions';

const unitMeasurementSlice = createSlice({
  name: 'unit_measurement',
  initialState: {
    unit_measurements: [],
    currentUnitMeasurement: null,
    loading: false,
    error: null,
  },
  reducers: {
    setCurrentUnitMeasurement: (state, action) => {
      state.currentUnitMeasurement = action.payload;
    },
    clearCurrentUnitMeasurement: (state) => {
      state.currentUnitMeasurement = null;
    },
    clearUnitMeasurements: (state) => {
      state.unit_measurements = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllUnitMeasurements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllUnitMeasurements.fulfilled, (state, action) => {
        state.loading = false;
        state.unit_measurements = action.payload.data || [];
      })
      .addCase(fetchAllUnitMeasurements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Erro ao buscar unidades de medida';
      })
      .addCase(createNewUnitMeasurement.fulfilled, (state, action) => {
        state.unit_measurements.push(action.payload);
      });
  },
});

export const { setCurrentUnitMeasurement, clearCurrentUnitMeasurement, clearUnitMeasurements } = unitMeasurementSlice.actions;
export default unitMeasurementSlice.reducer;
